import '../../styles/bitacora.style.css'
import { useSelector } from 'react-redux'
import BasicCardDocumentos from '../DatosDeCierre/BasicCardDocumentos'
import { State } from '../../../../reducers'
import { useEffect, useState } from 'react'
import { Pagination } from '../../../../components/Pagination';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'

const TableDetalleCompras = () => {
  const {comprasLibroActivo} = useSelector((state: State) => state.libros);
  const {detalle} = comprasLibroActivo;
  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);

  useEffect(() => {
    setSortedArray(currentItems);
  }, [currentItems]);

  return (
    <div className="w-layout-layout bill-section wf-layout-layout">
      <BasicCardDocumentos 
        style={{boxShadow: 'none', padding: '0'}} 
        title="Detalle de libro" 
        size="l"
      >
        <div className="tab-plane">
          <div className="table-facturacion-resp">
            <table className="table-main-responsive responsive-table-main td-left table-pointer">
              <thead>
                <tr>
                  <td>No. <FilterButton keyName='numcorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Fecha Emisión <FilterButton keyName='fechaemision' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Número Comprobante <FilterButton keyName='numcomprobante' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Número Registro <FilterButton keyName='numregistro' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Nombre Proveedor <FilterButton keyName='nombreproveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Locales <FilterButton keyName='exentaslocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Importaciones <FilterButton keyName='exentasimportacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Internacionales <FilterButton keyName='exentasinternacional' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Locales <FilterButton keyName='gravadaslocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Importaciones <FilterButton keyName='gravadasimportacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Internacionales <FilterButton keyName='gravadasinternacional' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Crédito Fiscal IVA <FilterButton keyName='creditofiscaliva' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Total Compras <FilterButton keyName='totalcompras' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Percepción <FilterButton keyName='percepcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Retención <FilterButton keyName='retencion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                </tr>
              </thead>
              <tbody>
                {
                  sortedArray?.length > 0 && 
                  (
                    sortedArray.map((item: any) => (
                      <tr key={item.numcorrelativo}>
                        <td data-label='No.'>{item.numcorrelativo}</td>
                        <td data-label='Fecha Emisión'>{item.fechaemision}</td>
                        <td data-label='Número Comprobante'>{item.numcomprobante}</td>
                        <td data-label='Número Registro'>{item.numregistro}</td>
                        <td data-label='Nombre Proveedor'>{item.nombreproveedor}</td>
                        <td data-label='Exentas Locales'>{item.exentaslocales}</td>
                        <td data-label='Exentas Importaciones'>{item.exentasimportacion}</td>
                        <td data-label='Exentas Internacionales'>{item.exentasinternacional}</td>
                        <td data-label='Gravadas Locales'>{item.gravadaslocales}</td>
                        <td data-label='Gravadas Importaciones'>{item.gravadasimportacion}</td>
                        <td data-label='Gravadas Internacionales'>{item.gravadasinternacional}</td>
                        <td data-label='Crédito Fiscal IVA'>{item.creditofiscaliva}</td>
                        <td data-label='Total Compras'>{item.totalcompras}</td>
                        <td data-label='Percepción'>{item.percepcion}</td>
                        <td data-label='Retención'>{item.retencion}</td>
                      </tr>
                    ))
                  )
                }
              </tbody>
            </table>
            {detalle?.length > 0 && (
              <Pagination
                data={detalle}
                state={(items: Array<any>) => setCurrentItems(items)}
                items={20}
              />
            )}
          </div>
        </div>
      </BasicCardDocumentos>
    </div>
  )
}

export default TableDetalleCompras
